import React, { useMemo } from "react";

import { useNewGlobalSearch } from "pages/[tenant]/search/hooks/useNewGlobalSearch";

import { ConsolePageForm } from "@Console/components/molecules/ConsolePageForm";

import { SingleTagContainer } from "./styles";

const SingleTag = ({ tag }) => {
  const { setSelectedTags, selectedTags } = useNewGlobalSearch();

  const isTagSelected = useMemo(
    () => !!selectedTags?.find((index) => index?.id === tag?.id),
    [selectedTags],
  );

  const handleSelectTag = () => {
    if (isTagSelected)
      setSelectedTags((prev) => prev?.filter((item) => item?.id !== tag?.id));
    else setSelectedTags((prev) => [...prev, tag]);
  };

  return (
    <SingleTagContainer onClick={handleSelectTag}>
      <ConsolePageForm.Checkbox
        checked={isTagSelected}
        handleChange={() => null}
      />
      <p className="tag-label">{tag?.label}</p>
    </SingleTagContainer>
  );
};

export default SingleTag;
